<template>
  <div :key="$store.getters['resource/currentResource'].key">

    <filters
      class="white-container"
      v-if="filters"
      :inputs="filters"
      @filter="filter"
      :extendButton="false"
      :extended="true"
      :loading="loading"
    >
    </filters>

    <div class="position-relative">

      <loader v-if="loading"/>

      <v-server-table
        ref="appTable"
        name="partnersTable"
        class="white-container"
        url="/admin/partners"
        :columns="columns"
        :options="options"
        @loaded="loading = false"
        @loading="loading = true">
        <template slot="beforeFilter">

          <b-row>
            <b-col>
              <router-link to="partners/create">
                <b-button
                  class="px-4 mb-3"
                >{{ $t('partners.add_new_partner') }}
                </b-button>
              </router-link>
            </b-col>
          </b-row>

        </template>

        <template slot="beforeLimit" v-if="totalRecordsCount > 10">
          {{$t('global.showing')}}&nbsp;
        </template>
        <template slot="afterLimit" v-if="totalRecordsCount > 10">
          &nbsp;{{$t('global.of_records_found', {number: totalRecordsCount})}}
        </template>
        <template slot="active" slot-scope="props">
          <column-check :row="props.row" column="active"/>
        </template>
        <template slot="created_at" slot-scope="props">
          <column-date :row="props.row" column="created_at" format="L"/>
        </template>
        <template slot="updated_at" slot-scope="props">
          <column-date :row="props.row" column="updated_at" format="L"/>
        </template>
        <template slot="actions" slot-scope="props">
          <column-action
            :showDeleteButton="true"
            :delete-url="`partners/${props.row.id}`"
            @deleteItems="$refs.appTable.refresh()"
            :route="{path: `/partners/edit/${props.row.id}`, params: {id: props.row.id}}"
          />
        </template>
      </v-server-table>
    </div>
  </div>

</template>

<script>
  import axios from '@/utils/axios';
  import {Event} from 'vue-tables-2';
  import i18n from "@/utils/i18n";
  import filters from '@/components/global/filters';
  import partnersFilters from './partnersFilters';

  export default {
    middleware: ['auth', 'root-auth'],
    name: 'Emails',
    components: {
      filters
    },
    data: () => {
      return {
        loading: false,
        totalRecordsCount: null,
        filters: partnersFilters,
        params: {
          page: 1,
          filter: {}
        },
        columns: ['title', 'id', 'active', 'created_at', 'updated_at', 'actions'],
        options: {
          skin: [],
          headings: {
            title: i18n.t('form.title'),
            id: '#',
            active: i18n.t('form.active'),
            created_at: i18n.t('form.created_at'),
            updated_at: i18n.t('form.updated_at'),
            actions: i18n.t('button.edit')
          },
          sortable: [],
          dateColumns: ['created_at'],
          columnsDropdown: false,
          filterByColumn: false,
          customFilters: ['custom'],
          perPage: !!localStorage.getItem('perPage') && localStorage.getItem('perPage') !== '' ? localStorage.getItem('perPage') : 10,
          filterable: false,
          requestFunction: function (data) {
            localStorage.setItem('perPage', data.limit);
            return axios.get(this.url, {
              params: {
                filter: data.custom,
                limit: data.limit,
                page: data.page
              }
            }).catch((e) => {
              // this.$noty.error(e.error_description);
              this.dispatch('error', e);
            });
          },
          responseAdapter: function (resp) {
            let data = this.getResponseData(resp);
            return {
              data: data.data.items,
              count: data.data.paginator.total_items
            }
          }
        },
      }
    },
    mounted() {
      Event.$on('vue-tables.partnersTable.loaded', ({data}) => {
        this.totalRecordsCount = data.paginator.total_items
      });
    },
    methods: {
      filter(params) {
        this.params = params;
        Event.$emit('vue-tables.partnersTable.filter::custom', params)
      }
    },
    destroyed() {
      Event.$off('vue-tables.partnersTable.loaded');
    }
  }
</script>
